<template >
    <div id="t1">
        <div class="juzhon">
            <div class="boxtitle">
                <span class="tit_left"><img src="../assets/zbtj.png" ></span>
                <span class="tit_right"><a :href="curl+2836" target="_blank"> 更多资讯>></a></span>
            </div>

            <div class="videoBox" v-if="spshow">

                <div class="left">
                    <video :src="lists[sp].videoUrl" :poster="lists[sp].pic1"  width="1020px" height="570px" controls="controls" ></video>
                    <div class="vidtitle"><span>{{ lists[sp].title }}</span></div>
                </div>
                
                <div class="right">
                    <ul>
                        <li v-for="(item,i) in lists" :key="i" @click='sp=i'  class="lh_bounce_to_right">
                            <a ><b>{{i+1}}</b>{{item.title}}</a>
                        </li>
                    </ul>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {inject,ref,onMounted} from 'vue'
export default {
    name:'T1',
    setup(){
        let ztreq=inject('ztreq')
        let aurl=ztreq.data.aurl
        let curl=ztreq.data.curl
        let lists=ref([{videoUrl:"",pic1:""}])
        let sp=ref(0)
        let spshow=ref(false)
        onMounted(()=>{
                axios.get(ztreq.data.geturl+'2836&pageSize=4&articleType=2').then((res)=>{
                lists.value = res.data.list
                if(lists.value.length>0){
                    spshow.value=true
                }
            });
        });
        return{
            aurl,lists,curl,sp,spshow
        }
    }  

}
</script>

<style scoped>
#t1{
    min-width: 1200px;
    width:100%;
    height: 660px;   
    background-color: #FFF;
    padding-top: 40px;
}
.boxtitle{
    width: 1200px;
    height: 48px;
    overflow: hidden;
    border-bottom: 4px solid #fc0000;
    margin-bottom: 20px;
}
.boxtitle img{
    width: 157px;
}
.tit_left{
    float: left;
}
.tit_right{
    float: right;
    font-size: 18px;
    color: #333;
    margin-top: 18px;
}
.tit_right a{
    font-size: 18px;
    color: #333;
}
.tit_right a:hover{
    color: #fc0000;
    text-decoration: underline;
}

.vidtitle{
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    color: #0a0909;
}
.vidtitle span{
    width: 600px;
    font-size: 18px;
    white-space: nowrap;
    line-height: 24px;
    z-index: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.videoBox{
    width: 1200px;
    height: 520px;
    margin-top: 40px;
}
.videoBox .left{
    display: inline-block;
    width: 740px;
    height: 511px;
    background: url(../assets/video_bg.png) no-repeat top center;
}

.videoBox video{
    width: 727px;
    height: 411px;
    margin: 14px 0 0 6px;
    background-color: #000000;
}

.videoBox .right{
    display: inline-block;
    width: 440px;
    height: auto;
    border: 1px solid #889;
    margin-top: 26px;
    float: right;
}

.right li{
    width: 400px;
    height: 60px;
    line-height: 26px;
    font-size: 14px;
    padding: 20px;
    background: #eaeff8;
}
.right li:nth-child(-n+3){
    margin-bottom: 4px;
}
.right li b{
    display: inline-block;
    line-height: 60px;
    font-size: 24px;
    font-style: italic;
    font-weight: bold;
    color: #0a0909;;
    margin-right: 13px;
    z-index: 1;
}

.right li:hover a>b{
    color: #fff;
}
.right li:hover>a{
    color: #fff;
    cursor:pointer;
}
.right li a{
    width: 420px;
    font-size: 18px;
    white-space: nowrap;
    line-height: 60px;
    color: #0a0909;
    z-index: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

/* 动画 */
.lh_bounce_to_right{display:inline-block;vertical-align:middle;-webkit-transform:perspective(1px) translateZ(0);transform:perspective(1px) translateZ(0);box-shadow:0 0 1px transparent;position:relative;-webkit-transition-property:color;transition-property:color;-webkit-transition-duration:0.5s; transition-duration:0.5s;}
.lh_bounce_to_right:before{content:"";position:absolute;z-index:-1;top:0;left:0;right:0;bottom:0;background:#c71b1b;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:0 50%;transform-origin:0 50%;-webkit-transition-property:transform;transition-property:transform;-webkit-transition-duration:0.5s;transition-duration:0.5s;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;}
.lh_bounce_to_right:hover, .lh-bounce-to-right:focus, .lh-bounce-to-right:active {color:#fff;}
.lh_bounce_to_right:hover:before, .lh-bounce-to-right:focus:before, .lh-bounce-to-right:active:before{-webkit-transform:scaleX(1);transform:scaleX(1);opacity:0.9;-webkit-transition-timing-function:cubic-bezier(0.52, 1.64, 0.37, 0.66);transition-timing-function:cubic-bezier(0.52, 1.64, 0.37, 0.66);}
</style>